
import awsImg from "./images/aws.jpg"
import hotelImg from "./images/hotel.jpg"
import pawcketImg from "./images/pawcket.jpg"


import { SiExpress, SiMongodb } from "react-icons/si";
import { AiFillGithub, AiFillLinkedin, AiFillYoutube } from "react-icons/ai";
import { TbBrandReactNative } from "react-icons/tb";
import {
  SiAmazonwebservices,  
  SiDocker,
  SiJest,
  SiPassport,
  SiJsonwebtokens,
  SiMarkdown,
  SiCloudinary,
  SiJira,
  SiMysql,
  SiApachemaven,      
  SiJunit5,           
} from "react-icons/si";
import { FaNodeJs, FaJava } from "react-icons/fa";

export const menu = [
  { name: "About" },
  { name: "Services" },
  { name: "Skill" },
  { name: "Projects" },
  { name: "Testimonial" },
  { name: "Contact" },
];

export const projects = [
  {
    id: 101,
    title: "Fragments Microservice",
    image: awsImg,                          
    category: "AWS",
    data: {
      description: `Cloud-native microservice for storing and converting small text/image fragments. 
      Provides CRUD over REST API with JWT/Passport authentication, Markdown→HTML and image format conversions. 
      Deployed on AWS with Docker, CI/CD via GitHub Actions, and scalable storage using S3 & DynamoDB.`,
      demoLink: "https://youtu.be/Sn8c8ltCzf8",
    },
    stack: [
      { name: "AWS",      icon: <SiAmazonwebservices /> }, 
      { name: "Node.js",  icon: <FaNodeJs /> },
      { name: "Express",  icon: <SiExpress /> },
      { name: "Docker",   icon: <SiDocker /> },
      { name: "Jest",     icon: <SiJest /> },
      { name: "Passport", icon: <SiPassport /> },
      { name: "JWT",      icon: <SiJsonwebtokens /> },
      { name: "Markdown", icon: <SiMarkdown /> },
    ],
  },
  {
    id: 102,
    title: "Hotel Reservation System",
    image: hotelImg,                        
    category: "Desktop Application",
    data: {
      description: `A Java-based desktop application for managing hotel room bookings,
      customers, and reservations. Includes functionality for searching available rooms,
      making new reservations, and generating booking reports. Fully tested with JUnit to ensure reliability.`,
      demoLink: "https://youtu.be/db-bUJVXqDE",
    },
    stack: [
      { name: "Java",   icon: <FaJava />,       iconColor: "orange" },
      { name: "MySQL",  icon: <SiMysql />,      iconColor: "skyblue" },
      { name: "Maven",  icon: <SiApachemaven />,iconColor: "red" },   
      { name: "JUnit",  icon: <SiJunit5 />,     iconColor: "green" }, 
    ],
  },
  {
    id: 103,
    title: "Pawcket - Pet Care Community App",
    image: pawcketImg,                      
    category: "Mobile Application",
    data: {
      description: `A cross-platform mobile application built with React Native to connect pet owners 
      and service providers. Features include pet profile management, community-based pet sitting, 
      location-based search for veterinarians/services, QR-code based service exchange, and activity tracking. 
      Developed using Agile methodology with iterative sprints and user stories.`,
      demoLink: "https://youtube.com/shorts/377yLbHxTjA",
    },
    stack: [
      { name: "React Native", icon: <TbBrandReactNative />, iconColor: "skyblue" },
      { name: "Node.js",      icon: <FaNodeJs />,           iconColor: "green" },
      { name: "Express.js",   icon: <SiExpress /> },
      { name: "MongoDB",      icon: <SiMongodb />,          iconColor: "limegreen" },
      { name: "Cloudinary",   icon: <SiCloudinary />,       iconColor: "dodgerblue" },
      { name: "Agile/Jira",   icon: <SiJira />,             iconColor: "deepskyblue" },
    ],
  },
];

export const experience = [
  {
    title: "Mobile Development",
    data: [
      { skill: "Kotlin", level: "Intermediate" },
      { skill: "Flutter", level: "Intermediate" },
      { skill: "React Native", level: "Experienced" },
    ],
  },
  {
    title: "Data & Databases",
    data: [
      { skill: "SQL", level: "Experienced" },
      { skill: "SQLite", level: "Experienced" },
      { skill: "MongoDB", level: "Intermediate" },
    ],
  },
  {
    title: "Cloud & DevOps",
    data: [
      { skill: "AWS", level: "Intermediate" },
      { skill: "Docker", level: "Intermediate" },
    ],
  },
  {
    title: "Programming & Computer Vision",
    data: [
      { skill: "Python", level: "Intermediate" },
      { skill: "NumPy / OpenCV", level: "Intermediate" },
      { skill: "Algorithms", level: "Intermediate" },
    ],
  },
  {
    title: "Web Development",
    data: [
      { skill: "React", level: "Experienced" },
      { skill: "JavaScript", level: "Experienced" },
      { skill: "HTML5", level: "Experienced" },
      { skill: "CSS3", level: "Experienced" },
      { skill: "JSON / XML", level: "Experienced" },
    ],
  },
  {
    title: "Collaboration Tools",
    data: [
      { skill: "GitHub", level: "Experienced" },
      { skill: "Jira", level: "Experienced" },
      { skill: "Confluence", level: "Experienced" },
    ],
  },
];

export const socialHandles = [
  { name: "GitHub",   icon: <AiFillGithub />,   link: "https://github.com/HEYSHEED" },
  { name: "LinkedIn", icon: <AiFillLinkedin />, link: "https://www.linkedin.com/in/mahshid-shirazi-a03459253" },
  { name: "YouTube",  icon: <AiFillYoutube />,  link: "https://www.youtube.com/@sheedshirazi" },
];
